export default __webpack_public_path__ + "static/15.SHHKPS-2a9aee96f6672962b97fe646a83b3fee.png";